import { FC, useMemo } from 'react';
import { GaugeChart, LayoutCarousel, ProgressPolygonList } from '@silverfort/sf-components';
import usePairedUsers from './hooks/usePairedUsers';
import { Insights } from '../../types/Insights';
import useTokenTypeToCountMap from './hooks/useTokenTypeToCountMap';
import { splitArrayIntoBatches } from './utils';

interface Props {
    insights: Insights;
    isLoading: boolean;
}

const PairedUserStatisticsCard: FC<Props> = ({ insights, isLoading }) => {
    const pairedUsers = usePairedUsers(insights);
    const tokenTypeToCountMap = useTokenTypeToCountMap(insights);

    const batches = splitArrayIntoBatches(tokenTypeToCountMap, 3);

    const pages = useMemo(() => {
        const pagesArray = [
            <div className="flex flex-1 flex-row items-center w-full">
                <div className="flex justify-center flex-1">
                    <GaugeChart {...pairedUsers} isLoading={isLoading} />
                </div>
                <div className="flex-1">
                    <ProgressPolygonList items={batches[0] || []} isLoading={isLoading} />
                </div>
            </div>
        ];
        for (let i = 1; i < batches.length; i++) {
            const page = (
                <div className="flex flex-1 flex-row items-center w-full">
                    <div className="flex justify-center flex-1">
                        <GaugeChart {...pairedUsers} isLoading={isLoading} />
                    </div>
                    <div className="flex-1">
                        <ProgressPolygonList items={batches[i]} isLoading={isLoading} />
                    </div>
                </div>
            );
            pagesArray.push(page);
        }

        return pagesArray;
    }, [pairedUsers, batches, isLoading]);

    return (
        <LayoutCarousel
            title="Paired Users and Tokens"
            contentClassName="flex flex-1 flex-col justify-center px-6"
            pages={pages}
        />
    );
};

export default PairedUserStatisticsCard;
